import { Dispatch, FC, SetStateAction, useState } from 'react';
import { Button, Col, DropdownItem, Input, Label, Row } from 'reactstrap';
import { Modal } from '../../../Components/Custom/modal';
import { useAppDispatch } from '../../../app/hooks';
import { handleMultipleModalsWithOneState } from '../../../helpers/helpers';
import { createLicence } from './slice';

import Select from 'react-select';

export const CreateLicenceModal: FC<{
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  isOpen: boolean;
  id: number;
  setId: Dispatch<SetStateAction<number>>;
  product: any;
  setProduct: any;
  params: URLSearchParams;
}> = ({ isOpen, setIsOpen, id, setId, product, setProduct, params }) => {
  const dispatch = useAppDispatch();

  const options = [
    { value: 1, label: '1 year' },
    { value: 2, label: '3 years' },
    { value: 4, label: '1 year PROMO' },
    { value: 5, label: '3 years PROMO' },
    { value: 6, label: '1 year Builder' },
    { value: 7, label: '1 year Access' }
  ];

  const onSubmit = () => {
    setIsOpen(!isOpen);
    dispatch(createLicence({ id, productId: product.value, params }));
  };

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={() => setIsOpen(!isOpen)}
      title={'Create Order'}
      actions={
        <>
          <Button
            color='primary'
            outline
            onClick={() => setIsOpen(false)}
            className='m-1'>
            Cancel
          </Button>
          <Button
            color='primary'
            className='m-1'
            onClick={onSubmit}
            disabled={!id || !product}>
            Create
          </Button>
        </>
      }>
      <Col lg={12}>
        <Row>
          <Col lg={12}>
            <Label className='w-100 text-left' for='userId'>
              User ID
            </Label>
            <Input
              id='userId'
              className='w-100 mb-2'
              type='number'
              value={id}
              onChange={(e) => setId(parseInt(e.target.value))}
              placeholder='Enter here'
            />
          </Col>
        </Row>
        <Row>
          {/* <Select options={options} /> */}
          <Label className='w-100 text-left mt-3' for='userId'>
            Licences
          </Label>
          <Select
            // value={getValue}
            onChange={(e: any) => setProduct(e)}
            options={options}
            placeholder={'Select Licence'}
          />
        </Row>
      </Col>
    </Modal>
  );
};
